module.exports = __webpack_public_path__ + "img/video-popup.6a813524.png";